import {Injectable} from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import {WorkSheet} from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() {
  }

  public exportAsExcelFile(worksheets: Array<Array<any[]>>, sheetNames: Array<string>, excelFileName: string): void {
    const sheets: { [sheet: string]: WorkSheet } = {};
    for (let i = 0; i < worksheets.length; i++) {
      sheets[sheetNames[i]] = XLSX.utils.json_to_sheet(worksheets[i]);
    }

    const excelBuffer: any = XLSX.write({Sheets: sheets, SheetNames: sheetNames},
      {bookType: 'xlsx', type: 'buffer'});
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}




// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/services/excel-service.service.ts